import { render, staticRenderFns } from "./SearchResultBoard.vue?vue&type=template&id=6ab8958e"
import script from "./SearchResultBoard.ts?vue&type=script&lang=ts&external"
export * from "./SearchResultBoard.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports